import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { getLanguageCookie } from 'src/assets/language';
import { addAlert, apiOfflineAsync } from "../../../../layouts/pages/pages.component";
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { parse, stringify, v4 } from 'uuid';
import { to64decode } from 'src/app/helpers/base64';
import { sortArrayOfObjects } from 'src/app/helpers/sortArrayOfObjects';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { MatTableDataSource } from '@angular/material/table';
import { PersonasService } from 'src/app/services/personas/personas.service';
import { personasArray } from 'src/assets/const/personasCrudJson'; 

@Component({
  selector: 'app-personas-crud',
  templateUrl: './personas-crud.component.html',
  styleUrls: ['./personas-crud.component.scss']
})
export class PersonasCrudComponent {
  @Output() toggleModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() getPersonasTree: EventEmitter<void> = new EventEmitter<void>();
  @Output() updateFiles: EventEmitter<any> = new EventEmitter<any>();

  @Input() parameters: any = {}

  history: any = {
    indexTable: { startIndex: 0, endIndex: 0 },
    currentPage: 1,
    itemsPerPage: 5,
    totalPages: 1,
    filteredDatasource: new MatTableDataSource<any>([]),
    searchText: '',
    displayedColunms: ['is_current', 'fte_min', 'fte_max', 'start_date', 'end_date', 'user', 'inclusion_date'],
    displayedRows: [],
    isShow: false
  }

  isEdit: boolean = false;
  isShowSkills: boolean = false;
  skillsArray: any
  openSkills: boolean = true;

  openSpecialties: boolean = true;
  specialtiesArray: any

  temp: any = {}

  newNode: any

  personasArray: any = personasArray
  searchPersonas: string = '';
  selectedPersonas: any = personasArray[0]

  seniority: any = {
    dataSource: new MatTableDataSource<any>([]),
    displayedColumns: ['seniority', 'level', 'fte_cost', 'history', 'delete'],
    currentPage: 1,
    currentPageReq: 1,
    itemsPerPage: 10,
    indexTable: { startIndex: 0, endIndex: 0 },
  }

  constructor(
    private personasService: PersonasService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    this.parameters.item.data.type = this.parameters.item.data.type ?? this.selectedPersonas.slug
    this.temp = JSON.parse(JSON.stringify(this.parameters.item));
    this.personasArray.forEach((item: any) => {
      if (item?.slug == this.parameters?.item?.data?.type) {
        this.choseItemSelect('personas', item)

        if (item.slug != 'persona') {
          this.parameters.item.data.cost = 0
        }
      }
    });


    if (!this.parameters.item || !this.parameters.item.rows || !this.parameters.item.rows.skills) {
      this.parameters.item.rows.skills = []
    }

    this.skillsArray = this.parameters.item.rows.skills ?? []
    this.specialtiesArray = this.parameters.item.rows.specialties ?? []

    if(!this.parameters?.item?.data?.variations){
      this.parameters.item.data.variations = []
    }
    this.seniority.dataSource.data = this.parameters?.item?.data?.variations
    
    await this.getTotalPages(); 
  }
    
  async activateHistory(uuid: string) {
    this.history.isShow = true
    await this.getPersonasHistory(uuid)
  }

  async getPersonasHistory(uuid: string) {
    try {
      const response: any = await this.personasService.getPersonasHistory(uuid).toPromise();
      if (response && response.data) {
        this.history.displayedRows = response.data
        this.history.filteredDatasource.data = this.history.displayedRows
        this.getTotalPages()
      } else {

        throw new Error('Erro ao consultar àrvore de personas!\nConsulte o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async getDisplayedRows(){
    if(this.history?.isShow){
      this.history.indexTable.startIndex = (this.history.currentPage - 1) * this.history.itemsPerPage;
      this.history.indexTable.endIndex = this.history.indexTable.startIndex + this.history.itemsPerPage;
    }else{
      this.seniority.indexTable.startIndex = (Number(this.seniority.currentPage) - 1) * Number(this.seniority.itemsPerPage);
      this.seniority.indexTable.endIndex = this.seniority.indexTable.startIndex + Number(this.seniority.itemsPerPage);
    }
  }

  async getTotalPages(isLastPage: boolean = false){
    if(this.history?.isShow){
      this.history.totalPages = Math.ceil(this.history.filteredDatasource.data.length / this.history.itemsPerPage)
      if (this.history.totalPages == 0) this.history.totalPages = 1
      if ((this.history.currentPage >= this.history.totalPages && this.history.totalPages > 0) || isLastPage) {
        this.history.currentPage = this.history.totalPages;
      }
    }else{
      this.seniority.totalPages = Math.ceil(this.seniority.dataSource.data.length / this.seniority.itemsPerPage);
      if (this.seniority.totalPages == 0) this.seniority.totalPages = 1
      if ((this.seniority.currentPage >= this.seniority.totalPages && this.seniority.totalPages > 0) || isLastPage) {
        this.seniority.currentPage = this.seniority.totalPages;
      }
    }
   
    await this.getDisplayedRows()
  }

  async choseItemsPage(number: number) {
    if(this.history?.isShow){
      this.history.currentPage = 1;
      this.history.itemsPerPage = number;     
    }else{
      this.seniority.itemsPerPage = number;
      this.getDisplayedRows()
    }
      
    this.getTotalPages()
  }

  getRows(slug: string = 'history'){
    if(slug == 'history'){
      return this.history.filteredDatasource.data.slice(this.history.indexTable.startIndex, this.history.indexTable.endIndex)
    }else{
      return this.seniority.dataSource.data.slice(this.seniority.indexTable.startIndex, this.seniority.indexTable.endIndex);
    }
  }

  getCurrentPages(): number{
    if(this.history?.isShow){
      return this.history.currentPage
    }else{
      return this.seniority.currentPage
    }
  }

  setCurrentPages(param: number){
    if(this.history?.isShow){
      this.history.currentPage = Math.max(1, Math.min(param, this.history.totalPages || 1));
      this.getDisplayedRows();
    }else{
      this.seniority.currentPage = Math.max(1, Math.min(param, this.seniority.totalPages || 1));
      this.getDisplayedRows();
    }
  }

  getItemsPerPage(): number{
    if(this.history?.isShow){
      return this.history.itemsPerPage
    }else{
      return this.seniority.itemsPerPage
    }
  }

  getTotalNumberPages(): number {
    if(this.history?.isShow){
      return this.history.totalPages || 1;
    }else{
      return this.seniority.totalPages || 1;
    }
  }

  async search() {
    if(this.history?.isShow){
      const searchText = this.history.searchText.toLowerCase()
      this.history.filteredDatasource.data = this.history.displayedRows.filter( (item: { name: any;}) => item.name.toLowerCase().includes(searchText));
    }
    this.getTotalPages()
  }

  getColumnsVariations(){
    return this.seniority.displayedColumns.slice(1)
  }

  async checkValue() {
    let total = this.getTotalPages()
    if (this.seniority.currentPage > total) this.seniority.currentPage = total;
  }

  choseItemSelect(type: string, value: any, element?: any) {
    switch (type) {
      case 'personas':
        this.selectedPersonas = value;
        this.parameters.item.data.type = value.slug
        break;
      default:
        break;
    }
  }

  getNames(name: any) {
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  exitModal(hide: boolean = true): void {
    if (!hide) {
      return
    }
    this.toggleModal.emit();
  }

  async modalClose() {
    await Promise.all([this.exitModal()]);
  }

  async editBusinessTree() {
    this.isEdit = !this.isEdit;
    this.parameters.isEdit = this.isEdit

    if (!this.isEdit) {
      this.parameters.item = JSON.parse(JSON.stringify(this.temp));
      this.ngOnInit()
    }
  }

  async parametersValidation() {
    let inputs: any = []
    let SameSeniorityLevel = false;
    let fteNull = false;
    let levelNull = false;

    if (!this.parameters.item.label) {
      inputs.push(this.getLanguages('personas/name'))
    }

    this.seniority?.dataSource?.data?.forEach((item1: any) => {
      this.seniority?.dataSource?.data?.forEach((item2: any) => {
        if(
          item1.seniority && item2.seniority &&
          item1.seniority.trim().toLowerCase() == item2.seniority.trim().toLowerCase() && 
          item1.level == item2.level && 
          item1.uuid != item2.uuid){
          item1.error = item2.error = "SameSeniorityLevel"
          this.cdr.detectChanges()
          SameSeniorityLevel = true;
        }
      });

      if(!item1.fte_cost){
        item1.error = "FteNull"
        fteNull = true;
      }

      if(!item1.level){
        item1.error = "LevelNull"
        levelNull = true;
      }
    });

    if (SameSeniorityLevel) {
      addAlert('orange', `${this.getLanguages('SameSeniorityLevel')}${inputs.join(`, `)}`)
      return false
    }else if(fteNull){
      addAlert('orange', `${this.getLanguages('FteNull')}${inputs.join(`, `)}`)
      return false
    }else if(levelNull){
      addAlert('orange', `${this.getLanguages('LevelNull')}${inputs.join(`, `)}`)
      return false
    }else{
      this.seniority?.dataSource?.data?.forEach((item1: any) => {
        delete item1.error
      })
    }
    
    if (inputs.length > 0) {
      addAlert('orange', `${this.getLanguages('mandatoryField')}${inputs.join(`, `)}`)
      return false
    }
    return true
  }

  async setPersonasTree() {
    this.parameters.item.rows.skills = this.skillsArray
    this.parameters.item.rows.specialties = this.specialtiesArray
    
    if (!await this.parametersValidation()) {
      return
    }
    
    if (this.parameters.isCreate){
      
      this.newNode = {
        uuid: v4(),
        data: this.parameters.item.data,
        label: this.parameters.item.label,
        master: this.parameters.item.master,
        rows: this.parameters.item.rows,
        children: [],
      }

      if (this.newNode.master == 'ROOT') {
        this.parameters.personas.push(this.newNode)
      } else {
        this.recursiveForEach(this.parameters.personas)
      }

      this.updateFiles.emit({ files: this.parameters.personas } )
      await this.modalClose()
      return
    }

    this.updateTree(this.parameters.personas, this.parameters.item);

    this.updateFiles.emit({ files: this.parameters.personas, item: this.parameters.item });
    await this.modalClose();
  }

  recursiveForEach(array: any) {
    array.forEach((item: any) => {
      if (item.uuid == this.parameters.item.master) {
        item.children.push(this.newNode)
      } else {
        if (item.children.length > 0) {
          this.recursiveForEach(item.children)
        }
      }
    });
  }

  updateTree(array: any, updatedItem: any) {
    for (let i = 0; i < array.length; i++) {
      const item = array[i];

      if (item.uuid === updatedItem.uuid) {
        array[i] = {
          ...item,
          ...updatedItem,
        };
      } else if (item.children && item.children.length > 0) {
        this.updateTree(item.children, updatedItem);
      }
    }
  }

  getSystemPermission(screen: string, action?: string) {
    return systemPermissionsNew(screen, action)
  }

  exitModalSkills() {
    this.parameters.is_search = true
    this.isShowSkills = !this.isShowSkills;
  }

  getArraySkillsPersona(event: any) {
    let tempArray = this.skillsArray.filter((item: any) => { return !item.created_at })

    this.skillsArray = []
    event.forEach((item: any) => {
      this.skillsArray.push(item)
    });
    tempArray.forEach((item: any) => {
      this.skillsArray.push(item)
    });

    this.parameters.item.rows.skills = this.skillsArray
  }

  getArraySpecialtiesPersona(event: any) {
    let tempArray = this.specialtiesArray.filter((item: any) => { return !item.created_at })

    this.specialtiesArray = []
    event.forEach((item: any) => {
      this.specialtiesArray.push(item)
    });
    tempArray.forEach((item: any) => {
      this.specialtiesArray.push(item)
    });

    this.parameters.item.rows.skills = this.skillsArray
  }

  flipSkills() {
    this.openSkills = !this.openSkills
  }

  flipSpecialties() {
    this.openSpecialties = !this.openSpecialties
  }

  addSkill() {
    if (!this.parameters.isEdit) {
      return
    }
    this.openSkills = true
    this.skillsArray.push(
      {
        uuid: v4(),
        name: '',
      }
    )
  }

    addSpecialties() {
    if (!this.parameters.isEdit) {
      return
    }
    this.openSpecialties = true
    this.specialtiesArray.push(
      {
        uuid: v4(),
        name: '',
      }
    )
  }

  removeSkill(uuid: number) {
    if (!this.parameters.isEdit) {
      return
    }
    let array_temp: any = []

    this.skillsArray.forEach((item: any) => {
      if (item.uuid != uuid) {
        array_temp.push(item)
      }
    });

    this.skillsArray = array_temp
    this.parameters.item.rows.skills = array_temp
  }

  
  removeSpecialties(uuid: number) {
    if (!this.parameters.isEdit) {
      return
    }
    let array_temp: any = []

    this.specialtiesArray.forEach((item: any) => {
      if (item.uuid != uuid) {
        array_temp.push(item)
      }
    });

    this.specialtiesArray = array_temp
    this.parameters.item.rows.specialties = array_temp
  }


  validateLevel(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
  
    if (value === '') {
      this.parameters.item.data.level = null;
      return;
    }
  
    const numericValue = parseInt(value, 10);
  
    if (!isNaN(numericValue)) {
      if (numericValue < 1) {
        this.parameters.item.data.level = 1;
        inputElement.value = '1';
      } else if (numericValue > 10) {
        this.parameters.item.data.level = 10;
        inputElement.value = '10';
      } else {
        this.parameters.item.data.level = numericValue;
      }
    }
  }
  
  allowOnlyNumbers(event: KeyboardEvent): void {
    const key = event.key;
    if (!/^[0-9]$/.test(key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key)) {
      event.preventDefault();
    }
  }

  isDataVariations(){
    return this.seniority.dataSource.data.length > 0
  }

  async newVariation() {
    if (!this.parameters.isEdit) {
      return;
    }
    const json = {
      uuid: v4(),
      seniority: '',
      level: '',
      fte_cost: '',
      history: '',
    };
    this.seniority.dataSource.data.push(json);
    this.parameters.item.data.variations = this.seniority.dataSource.data;
    this.seniority.dataSource.data = [...this.seniority.dataSource.data];

    await this.getTotalPages(true);
    await this.getDisplayedRows();
  }

  async deleteVariation(uuid: string) {
    if(!this.parameters.isEdit){
      return
    }

    this.seniority.dataSource.data = this.seniority.dataSource.data.filter((item: { uuid: string; }) => item.uuid !== uuid);
    
    this.parameters.item.data.variations = this.seniority.dataSource.data;
    
    await this.getDisplayedRows();
  }

  validateFte(event: KeyboardEvent, row: any): boolean {
    const charCode = event.charCode;
    const char = String.fromCharCode(charCode);

    if (!/[\d.,]/.test(char)) {
      event.preventDefault();
      return false;
    }
    
    if (char === '.' || char === ',') {
      const textarea = event.target as HTMLTextAreaElement;
      if (textarea.value.includes('.') || textarea.value.includes(',')) {
        event.preventDefault();
        return false;
      }
    }

    return true;
  }

  formatFte(event: Event, row: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    let value = textarea.value;

    value = value.replace(',', '.');
    
    value = value.replace(/[^\d.]/g, '');
    
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    
    if (parts.length === 2) {
      parts[1] = parts[1].substring(0, 2);
      value = parts.join('.');
    }
    
    row.fte_cost = value;
  }

  formatIntegerInput(value: string): string {
    return value.replace(/\D/g, '');
  }
}